var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "introduction" }, [
    _c(
      "div",
      { staticClass: "introduction__splash" },
      [
        _c("img", {
          staticClass: "introduction__image",
          attrs: { src: require("@/assets/images/portrait_intro_blanc.png") },
        }),
        _c("v-frame", { ref: "frame", staticClass: "introduction__frame" }, [
          _c("img", {
            staticClass: "introduction__logo",
            attrs: {
              src: require("@/assets/images/LOGO-OUB.svg"),
              alt: "Officine Universelle Buly",
            },
          }),
          _c("p", { staticClass: "introduction__title" }, [
            _c("span", { staticClass: "introduction__word" }, [
              _vm._v("Skin concierge"),
            ]),
          ]),
          _c("div", { staticClass: "introduction__subtitle" }, [
            _c("p", { staticClass: "introduction__subtitle-top" }, [
              _c("span", { staticClass: "introduction__word" }, [
                _vm._v("The"),
              ]),
              _c("span", { staticClass: "introduction__word" }, [
                _vm._v("natural"),
              ]),
              _c("br"),
            ]),
            _c("p", { staticClass: "introduction__subtitle-bottom" }, [
              _c("span", { staticClass: "introduction__word" }, [
                _vm._v("beauty"),
              ]),
              _c("span", { staticClass: "introduction__word" }, [
                _vm._v("expert"),
              ]),
            ]),
          ]),
          _c("p", { ref: "cta", staticClass: "introduction__cta" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t(
                    _vm.touch ? "homePage.BulyCtaMobile" : "homePage.bulyCta"
                  )
                ) +
                " "
            ),
          ]),
          _c("img", {
            attrs: {
              src: require("@/assets/icons/arrow-down.svg"),
              alt: "Officine Universelle Buly",
            },
          }),
        ]),
      ],
      1
    ),
    _c(
      "div",
      { ref: "languagesDiv", staticClass: "introduction__languages" },
      _vm._l(_vm.$i18n.messages, function (messages, locale) {
        return _c(
          "v-option",
          {
            directives: [
              {
                name: "touch",
                rawName: "v-touch:tap",
                value: () => _vm.setLocale(locale),
                expression: "() => setLocale(locale)",
                arg: "tap",
              },
            ],
            key: locale,
            class: [
              {
                "introduction__latin-locales": _vm.latinLocales.includes(
                  locale.toLowerCase()
                ),
                "introduction__korean-chinese-locales":
                  _vm.koreanAndChineseLocales.includes(locale.toLowerCase()),
                "introduction__japanese-locale": locale === "jp",
              },
              "introduction__language",
            ],
          },
          [
            _c("p", { staticClass: "introduction__locales" }, [
              _vm._v(" " + _vm._s(messages.localeName) + " "),
            ]),
          ]
        )
      }),
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }